import React from 'react';
import './Quiz.css';

class Question extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            checked: [false, false, false, false]
        }

        this.check = this.check.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
            this.setState({checked : [false, false, false, false]});
        }
    }

    check(i) {
        let checked = [false, false, false, false];
        checked[i] = true;
        this.setState({checked});
    }

    render() {
        let { question, answers, answer, selectHandler, i, author } = this.props; 
        let { checked } = this.state;

        return (<div className="question">
            <div className="question-title">
                <span>{question}</span> <span className="question-title__author">{author}</span>
            </div>
            <div className="question-inputs">
                {answers.map((ans, j) => 
                <div className="question-input__group" key={j}>
                    <input type="radio" id={ans} name={question} value={ans}
                    onChange={() => {selectHandler(ans === answer, i); this.check(j)}} checked={checked[j]}/>
                    <label htmlFor={ans}>
                    <svg width="18" height="18">
                        <rect width="18" height="18" style={{fill: ans, stroke: 'black', transform: 'tranlate(0 50)'}}/>
                    </svg>
                    </label>
                </div>
                )}
            </div>
        </div>)
    }
}

export default Question;